<template lang="pug">
  v-text-field( :rules="_rules" v-bind="$attrs" v-model="_value" @keydown="handleKeyDown" )
    slot( name='append' slot='append' )
    slot( name='append-outer' slot='append-outer' )
    slot( name='prepend' slot='prepend' )
    slot( name='prepend-inner' slot='prepend-inner' )
</template>

<script>
  export default {
    name: 'rut-field',
    props: {

      /**
       * @description
       * { item_description }
       */
      value: {
        type: String,
        default: '',
      },

      /**
       * @description
       * { item_description }
       */
      rules: {
        type: Array,
        default: () => [],
      },
    },
    computed: {

      /**
       * @description
       * { function_description }
       *
       * @return     {<type>}  { description_of_the_return_value }
       */
      //__props() {
      //  return this.$attrs
      //},

      /**
       * @description
       * { function_description }
       *
       * @return     {<type>}  { description_of_the_return_value }
       */
      _rules() {
        return []//this.rules.concat(this.mapRule)
      },

      /**
       * @description
       * { item_description }
       */
      _value: {

        /**
         * @description
         * { property_description }
         *
         * @type       {<type>}
         */
        get() {
          return this.format(this.value)
        },

        /**
         * @description
         * { property_description }
         *
         * @type       {<type>}
         */
        set(value) {
          this.$emit('input', this.deform(value))
        },
      },
    },
    methods: {

      /**
       * @description
       * { function_description }
       *
       * @param      {string}  value   The value
       * @return     {string}  { description_of_the_return_value }
       */
      clean(value) {
        return value
          .toString()
          .replace(/\./g, '')
          .replace(/-/g, '')
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {Array}   value     The value
       * @return     {string}  { description_of_the_return_value }
       */
      format(value) {

        //
        let full = this.clean(value)
        let body = full.split('').slice(0, -1).join('')
        let last = full.split('').slice(-1).join('')

        //
        body = body
          .replace(/\D/g, '')
          .split('')
          .reverse()
          .reduce( (t, c, i) => t + ( i%3 || i === 0 ? c : '.' + c), '')
          .split('')
          .reverse()
          .join('')

        //
        return `${body}${body.length ? '-' : ''}${last}`
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {Array}  value     The value
       * @return     {Array}  { description_of_the_return_value }
       */
      deform(value) {

        //
        let full = this.clean(value)
        let body = full.split('').slice(0, -1).join('')
        let last = full.split('').slice(-1).join('')

        //
        return `${body}${body.length ? '-' : ''}${last}`
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {Function}  f       { parameter_description }
       * @return     {<type>}    { description_of_the_return_value }
       */
      mapRule(f) {
        return f(this.value)
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {<type>}  e       { parameter_description }
       * @return     {<type>}  { description_of_the_return_value }
       */
      handleKeyDown(e) {
        if (e.ctrlKey && e.key === 'v') {
          return
        }
        /*if (e.key.length === 1 && this.value.length === 1 &&) {
          this.handlePreventPropagation()
          return
        }*/
        if (e.key.length === 1 && this.value.includes('k') && e.key === 'k') {
          this.handlePreventPropagation(e)
          return
        }
        if (e.key.length === 1 && (isNaN(e.key) && e.key !== 'k')) {
          this.handlePreventPropagation(e)
          return
        }
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      handlePreventPropagation(event) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
  }
</script>
